<template>

    <information-modal title="Upload Report"
        :show-modal="isShowUploadReport"
        @dismiss="hideUploadReport">
        <form @submit.prevent="uploadReport">

            <fieldset class="border-bottom mb-3">
                <div class="mb-3 row">
                    <div class="col-md-3">
                        <label for="uploadReportFile"
                            class="col-form-label">File:</label>
                    </div>
                    <div class="col-md-8">

                        <file-input v-model="uploadReportFile"
                            id="uploadReportFile"
                            name="uploadReportFile"
                            :error="errors.file"></file-input>
                    </div>
                </div>

            </fieldset>

            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">Cancel</button>
                <button type="submit"
                    class="btn btn-primary">Save</button>
            </div>
        </form>
    </information-modal>

    <information-modal title="Edit Audit"
        v-if="editAudit"
        :show-modal="isShowEditEditor"
        @dismiss="hideEditEditor">
        <form @submit.prevent="updateAudit">
            <fieldset class="border-bottom mb-3">

                <div class="mb-3 row align-items-center">
                    <label for="disabledSelect"
                        class="col-sm-3 col-form-label">Agency:</label>
                    <div class="col-sm-9">
                        {{ editAudit.agencyName }}
                    </div>
                </div>

                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Period of Audit:</label>
                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col">
                                <label for="startMonth"
                                    class="col-form-label">Start Month:</label>
                                <Datepicker v-model="startMonth"
                                    :clearable="false"
                                    :enable-time-picker="false"
                                    :class="{ 'is-invalid': !!errors.startMonth}"
                                    :month-picker="true"
                                    format="MM-yyyy"
                                    :input-class-name="!!errors.startMonth?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.startMonth">
                                    {{ errors.startMonth}}
                                </span>
                            </div>
                            <div class="col">
                                <label for="endMonth"
                                    class="col-form-label">End Month:</label>
                                <Datepicker v-model="endMonth"
                                    :clearable="false"
                                    @update:model-value="editAudit.endMonth=new Date(endMonth.year, endMonth.month, 0)"
                                    :month-picker="true"
                                    format="MM-yyyy"
                                    :class="{ 'is-invalid': !!errors.endMonth}"
                                    :enable-time-picker="false"
                                    :input-class-name="!!errors.endMonth?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.endMonth">
                                    {{ errors.endMonth}}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Audit to Take Place:</label>
                    <div class="col-sm-9">
                        <div class="row">
                            <div class="col">
                                <label for="startDate"
                                    class="col-form-label">Start Date:</label>
                                <Datepicker :format="dateFormat"
                                    v-model="editAudit.startDate"
                                    id="startDate"
                                    :clearable="false"
                                    :class="{ 'is-invalid': !!errors.startDate}"
                                    :enable-time-picker="false"
                                    :input-class-name="!!errors.startDate?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.startDate">
                                    {{ errors.startDate}}
                                </span>
                            </div>
                            <div class="col">
                                <label for="plannedEndDate"
                                    class="col-form-label">Planned End Date:</label>
                                <Datepicker :format="dateFormat"
                                    id="plannedEndDate"
                                    v-model="editAudit.plannedEndDate"
                                    :clearable="false"
                                    :enable-time-picker="false"
                                    :input-class-name="!!errors.plannedEndDate?'form-control is-invalid':'form-control'">
                                </Datepicker>
                                <span class="invalid-feedback"
                                    role="alert"
                                    v-if="errors.plannedEndDate">
                                    {{ errors.plannedEndDate}}
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="mb-3 row">
                    <label for="auditorName"
                        class="col-sm-3 col-form-label">Auditor Name:</label>
                    <div class="col-sm-9">

                        <text-input name="auditorName"
                            type="text"
                            v-model="editAudit.auditorName"
                            :error="errors.auditorName" />

                    </div>
                </div>
                <div class="mb-3 row">
                    <label for="disabledTextInput"
                        class="col-sm-3 col-form-label">Auditor Email Address:</label>
                    <div class="col-sm-9">
                        <text-input name="auditorName"
                            type="text"
                            v-model="editAudit.auditorEmailAddress"
                            :error="errors.auditorEmailAddress" />
                    </div>
                </div>

                <div class="mb-3 row align-items-start">
                    <label for="disabledSelect"
                        class="col-sm-3 col-form-label">Notices:</label>
                    <div class="col-sm-9 mt-2">
                        <audit-details-notices :run-audits="runAudits"
                            v-model="editAudit.notices"
                            :create-audits="createAudits"
                            :audit="audit"
                            :id="id"></audit-details-notices>
                    </div>
                </div>

            </fieldset>
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button"
                    class="btn btn-secondary"
                    data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary"
                    type="submit">Save</button>
            </div>
        </form>
    </information-modal>

    <div class="mt-5 mb-3 details">
        <table class="table-sm mb-3">
            <tr>
                <th>Agency:</th>
                <td>
                    <span>
                        {{audit.agencyName }}
                    </span>
                </td>
            </tr>
            <tr>
                <th>Status:</th>
                <td>
                    <span>
                        {{audit.status }}
                    </span>
                </td>
            </tr>
            <tr>
                <th>Period of Audit:</th>
                <td>
                    <span class="val"> {{ audit.startMonth }}

                        <span class="me-1 ms-1">
                            through
                        </span>
                        {{ audit.endMonth }}</span>
                </td>
            </tr>
            <tr>
                <th>Audit to Take Place:</th>
                <td>
                    <span class="val"> {{ audit.startDate }}
                        <span class="me-1 ms-1">
                            to
                        </span>
                        {{ audit.plannedEndDate }}</span>
                </td>
            </tr>
            <tr>
                <th>Auditor Contact Details:</th>
            </tr>
            <tr>
                <td colspan="2">
                    <div class="col-12 offset-3 pb-0 pt-0">
                        <div class="row ">
                            <div class="col col-auto col-title"> <span class="title-bold">Name:</span></div>
                            <div class="col"> <span class="val">{{audit.auditorName }}</span></div>
                        </div>
                        <div class="row ">
                            <div class="col col-auto col-title"> <span class="title-bold">Email:</span></div>
                            <div class="col"> <span class="val">{{audit.auditorEmailAddress }}</span></div>
                        </div>
                    </div>
                </td>
            </tr>
            <tr>
                <th>Notices:</th>
                <td>
                    <span class="val"
                        v-if="audit.notifications">{{ audit.notifications }} notice types enabled</span>
                    <span class="val"
                        v-else>No notice type enabled</span>
                </td>
            </tr>

        </table>

        <button type="button"
            v-if="canEdit"
            @click.prevent="showEditEditor"
            class="btn btn-primary me-2">Edit</button>

        <button type="button"
            v-if="canShowClose"
            @click.prevent="closeAudit"
            class="btn btn-danger me-2">Close Audit</button>

        <button type="button"
            v-if="canUploadReport"
            @click="showUploadReport"
            class="btn btn-primary me-2">Upload Report</button>

        <button type="button"
            v-if="canShowCancel"
            @click.prevent="closeAudit"
            class="btn btn-danger me-2">Cancel Audit</button>

        <a v-if="canViewReport"
            :href="`api/v1/audit/file/${audit.reportFileId}`"
            class="btn btn-secondary">View Report</a>

        <button type="button"
            v-if="canReplaceReport"
            @click="showUploadReport"
            class="btn btn-primary mx-2">Replace Report</button>
    </div>
</template>
<script lang="ts" setup>
import { Audit, AuditEdit } from "@/audit.types";
import { useAuditStore } from "@/stores/auditStore";
import { clone } from "@/utils";
import { useFormValidation } from "@/validation";
import { computed, onMounted, ref } from "vue";
import { date, mixed, object, string } from "yup";
import InformationModal from "../Misc/InformationModal.vue";
import TextInput from "../Fields/TextInput.vue";
import FileInput from "../Fields/FileInput.vue";
import Datepicker from "@vuepic/vue-datepicker";
import AuditDetailsNotices from "./AuditDetailsNotices.vue";

const dateFormat = "yyyy-MM-dd";
const props = defineProps<{
    id: number;
    audit: Audit;
    runAudits: boolean;
    createAudits: boolean;
}>();

const emit = defineEmits(["reload"]);

const auditStore = useAuditStore();
const editAudit = ref<AuditEdit>();
const uploadReportFile = ref<File | null>();

const schema = object<AuditEdit>({
    startDate: date().required().label("Start Date"),
    startMonth: date().required().label("Start Month"),
    auditorName: string().required().label("Auditor Name"),
    auditEmailAddress: string().email().label("Audit Email Address"),
});
const canShowCancel = computed(
    () =>
        props.runAudits &&
        (props.audit.statusCode == "AN" || props.audit.statusCode == "AP") &&
        (!props.audit.documents || props.audit.documents == 0)
);
const canShowClose = computed(
    () =>
        props.runAudits &&
        props.audit.statusCode == "AP" &&
        props.audit.documents &&
        props.audit.documents != 0
);

const closeAudit = async function () {
    await auditStore.close(props.id!);
    await fetchDetails();
};
const canViewReport = computed(() => props.audit.reportFileId);

const canUploadReport = computed(
    () =>
        props.runAudits &&
        props.audit.statusCode != "AC" &&
        !props.audit.reportFileId
);

const canReplaceReport = computed(
    () =>
        props.runAudits &&
        props.audit.reportFileId &&
        props.audit.statusCode != "AC"
);

const canEdit = computed(
    () => props.runAudits && props.audit.statusCode != "AC"
);

const isShowUploadReport = ref(false);

const showUploadReport = function () {
    isShowUploadReport.value = true;
};

const hideUploadReport = function () {
    isShowUploadReport.value = false;
};

const { handleSubmit, errors } = useFormValidation();

const uploadReportSchema = object().shape({
    file: mixed().required().label("File"),
});

const uploadReport = async function () {
    if (
        await handleSubmit(uploadReportSchema, { file: uploadReportFile.value })
    ) {
        await auditStore.upload(props.id!, uploadReportFile.value!);
        hideUploadReport();
        await fetchDetails();
        uploadReportFile.value = null;
    }
};

const isShowEditEditor = ref(false);

const showEditEditor = function () {
    isShowEditEditor.value = true;
};
const hideEditEditor = function () {
    isShowEditEditor.value = false;
};

const updateAudit = async () => {
    if (await handleSubmit(schema, editAudit.value)) {
        await auditStore.update(props.id, editAudit.value);
        await fetchDetails();
        await hideEditEditor();
    }
};

onMounted(() => {
    editAudit.value = <AuditEdit>(<unknown>clone(props.audit));
    let date = new Date(props.audit.startMonth);
    startMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };
    date = new Date(props.audit.endMonth);
    endMonth.value = {
        month: date.getMonth(),
        year: date.getFullYear(),
    };
});

const fetchDetails = async () => {
    emit("reload");
};

const startMonth = ref();
const endMonth = ref();
</script>

<style lang="scss">
.details {
    table {
        td,
        th {
            padding: 5px;
        }
    }
    .title-bold {
        font-weight: 700;
    }
}
</style>